import React from "react";
import Phase from '../components/Phase';
import Quote from '../components/Quote';
import Anime from 'react-anime';
import alice from '../assets/photos/headshots/m-headshot-alice.png';
import VerticalDropCopy from '../components/VerticalDropCopy';
export default ({ isActive }) => {
  const message = "In Phase 2, trials involve a larger group of patients over a significantly longer timeline. Patients become our partners and we rely on their feedback in tandem with state-of-the-art tools to collect data.";
  const quote = {
    author: null,
    position: 'Oncologist and Global Head of Translational Clinical Oncology at Novartis',
    img: alice,
    quote: [message]
  }
  const phaseOne = {
    phase: 2,
    title: 'Patients are our Partners',
    parts: '100-300',
    studyLength: 'Several months to 2 years',
    success: .7
  };
  const utm = 'https://www.novartis.com/clinicaltrials?utm_source=cnn&utm_medium=infographic&utm_campaign=2020-11-clinical-trials-cnn&utm_content=phase-2-link';
  const silos = [{size: .8, delay: 0},{size: 1, delay: 750},{size: .5, delay: 250}];
  return (
    <div className="component fifth-component hide-overflow">
      <VerticalDropCopy isActive={isActive} />
    
      <div>
        <Quote quote={quote} isActive={isActive} showQuotemark={false} />
        <Phase {...phaseOne} position="left" utm={utm} />
      </div>
    </div>
  );
};
